import $http, { handleError } from '@/plugins/axios'
import { extractChapterException } from '@/utils/helpers'

const RESOURCE_NAME = '/admin/tenants'

export default {
  fetchTenantsPaged (skipCount, maxResultCount, keyword) {
    return $http().get(`${RESOURCE_NAME}`, {
      params: {
        skipCount,
        maxResultCount,
        keyword
      }
    })
  },
  deleteTenant (itemId) {
    const route = `${RESOURCE_NAME}/${itemId}`
    return $http().delete(route)
  },
  create (tenant) {
    return $http().post(RESOURCE_NAME, tenant)
  },
  update (tenant) {
    return $http().put(`${RESOURCE_NAME}/${tenant.id}`, this.getFormData(tenant), { handleError: false })
      .catch(e => {
        const chapterException = extractChapterException(e)
        if (!chapterException || !chapterException.isTenantException) {
          handleError(e)
        }
        throw e
      })
  },
  get (id) {
    return $http().get(`${RESOURCE_NAME}/${id}`)
  }
}
